import { LOOSE_COMMODITY_SLUG } from "../constants/productDivision";

export function isLooseCommodityDivision(divisionSlug) {
  return String(divisionSlug || "").trim().toUpperCase() === LOOSE_COMMODITY_SLUG;
}

/** Division slug from an order line, catalog row, or nested product shape. */
export function getLineDivisionSlug(line) {
  return (
    line?.division_slug ??
    line?.adminProduct?.division?.slug ??
    line?.product?.division_slug ??
    null
  );
}

export function isLooseCommodityLine(line) {
  return isLooseCommodityDivision(getLineDivisionSlug(line));
}

function hasMoreThanDecimalPlaces(value, maxDecimals = 2) {
  const str = String(value);
  const dot = str.indexOf(".");
  if (dot < 0) return false;
  return str.length - dot - 1 > maxDecimals;
}

/**
 * Validate Modify & Accept quantity for a product division.
 * Mirrors backend assertValidQuantity / normalizeQuantity semantics.
 */
export function validateModifyAcceptQuantity(
  value,
  divisionSlug,
  { allowZero = false } = {},
) {
  if (value === "" || value === null || value === undefined) {
    return { ok: false, error: "Quantity is required" };
  }
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || (allowZero ? numeric < 0 : numeric <= 0)) {
    return {
      ok: false,
      error: allowZero
        ? "Quantity must be zero or greater"
        : "Quantity must be greater than zero",
    };
  }

  if (isLooseCommodityDivision(divisionSlug)) {
    if (hasMoreThanDecimalPlaces(numeric, 2)) {
      return {
        ok: false,
        error:
          "Quantity supports up to 2 decimal places for Loose Commodity products",
      };
    }
    return { ok: true, value: Math.round(numeric * 100) / 100 };
  }

  if (!Number.isInteger(numeric)) {
    return {
      ok: false,
      error: "Quantity must be a whole number for this product division",
    };
  }
  return { ok: true, value: numeric };
}

export function normalizeModifyAcceptQty(value, divisionSlug, options = {}) {
  const parsed = validateModifyAcceptQuantity(value, divisionSlug, options);
  return parsed.ok ? parsed.value : 0;
}
